module.exports = __webpack_public_path__ + "static/img/hua2.6f9ac91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hua2.png
// module id = RXlB
// module chunks = 1